import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { BankAccountDataService } from '../../services/bank-account-data.service';


@Component({
  selector: 'app-account-link',
  templateUrl: './account-link.component.html',
  styleUrls: ['./account-link.component.scss']
})
export class AccountLinkComponent implements OnInit {
  bankAccountList;
  accountData;
  selectedFip;
  popupData: any;
  breadcrumb: { "label": string; "link": any[]; }[] = [];

  showError: boolean = false;
  constructor(
    private accountService: BankAccountDataService,
    private route: Router) { }

  ngOnInit() {
    this.getSelectedFip();
    this.getLinkingAccounts();
    this.setBreadcrumb();
  }

  /**
   * Checking if any of the accounts is checked or not.If checked then, link those accounts.
   */
  linkAccount() {
    if (this.accountData.discoveredAccounts.some(res => { return res['linkRequested'] == true; })) {
      this.linkAccountApi();
    } else {
      this.showError = true;
    }
  }

  /**
   * Function to link the checked accounts.
   */
  linkAccountApi() {
    // this.accountData.eventID = this.accountService.getLinkingAccounts() ? this.accountService.getLinkingAccounts().eventID : '1';
    let accountData = Object.assign({}, this.accountData);

    accountData.discoveredAccounts = accountData.discoveredAccounts.filter((res) => {
      return res.linkRequested == true;
    });
    this.accountService.setLinkRequestedAccounts(accountData);
    this.route.navigate(['/set-nickname']);
  }

  /**
   * To get discovered Accounts
   * @returns void
   */
  getLinkingAccounts(): void {
    this.accountData = this.accountService.getLinkingAccounts();
    console.log(this.accountData," selected accounts.....");
    if(this.accountData.discoveredAccounts){
      this.accountData.discoveredAccounts.forEach(element => {
        element['linkRequested'] = true;
      });
    }
  }

  /**
   * Get Selected FIP
   * @returns void
   */
  getSelectedFip(): void {
    this.selectedFip = this.accountService.getSelectedFip();
  }

  setBreadcrumb() {
    this.breadcrumb = [
      { "label": "Account Linking", "link": ["/account-discover"] },
    ];
  }

}